import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Table, message, Input, Select, Button } from "antd";
import {
  req_list_ams_tvedbDepartment,
  req_downloadfile_ams_tvedbDepartment,
  req_delete_ams_tvedbDepartment,
  req_add_ams_tvedbDepartment,
  req_edit_ams_tvedbDepartment,
} from "../../api";
import {
  getNowAcademicYear,
  getNowAcademicSemester,
} from "../../utils/dateUtil";
import { API_BASE } from "../../utils/contrains";

class TvedbDepartment extends Component {
  state = {
    loading: false,
    item: null,
    items: [],
    editMode: true,
    academicYear: getNowAcademicYear(new Date()),
    academicSemester: getNowAcademicSemester(new Date()),
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_list_items();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    const { token } = this.props.user;
    const { academicYear, academicSemester } = this.state;
    const result = await req_list_ams_tvedbDepartment(
      academicYear,
      academicSemester,
      token
    );
    if (result.total) {
      const items = result.total > 0 ? result.data : [];
      this.setState({ items });
    }
  };

  api_add_item = async (item) => {
    //console.log(item);
    const { token } = this.props.user;
    const result = await req_add_ams_tvedbDepartment(item, token);
    if (result.status === "success") {
      this.api_list_items();
    } else {
      message.info(result.message);
    }
  };

  api_modify_item = async (item) => {
    const { token } = this.props.user;
    //console.log(item);
    const result = await req_edit_ams_tvedbDepartment(item, token);
    if (result.status === "success") {
      // message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  api_del_item = async (item) => {
    //console.log(item);
    const { schoolYear, schoolSemester } = item;
    const { token } = this.props.user;
    const result = await req_delete_ams_tvedbDepartment(
      schoolYear,
      schoolSemester,
      token
    );
    if (result.status === "success") {
      message.info(result.message);
      this.api_list_items();
    } else {
      message.info(result.message);
    }
  };

  api_downloadfile_items = async () => {
    const { academicYear, academicSemester } = this.state;
    const { token } = this.props.user;

    const fileUrl = await req_downloadfile_ams_tvedbDepartment(
      academicYear,
      academicSemester,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "校資庫科系清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "年度",
        width: 16,
        responsive: ["md"],
        render: (item) => {
          const { schoolYear, schoolSemester } = item;
          return (
            <div className="text-center">
              <span style={{ fontSize: "1em" }}>
                {" "}
                {schoolYear} / {schoolSemester}{" "}
              </span>
            </div>
          );
        },
      },
      {
        title: "學制名稱",
        width: 30,
        responsive: ["md"],
        render: (item) => {
          const { educationalSystemName } = item;
          return (
            <div>
              <span style={{ fontSize: "1em" }}> {educationalSystemName} </span>
            </div>
          );
        },
      },
      {
        title: "系所名稱",
        dataIndex: "departmentName",
        width: 40,
      },
      {
        title: "學制代碼",
        width: 30,
        responsive: ["md"],
        render: (item) => {
          const { educationalSystemCode } = item;
          return (
            <div>
              <span style={{ fontSize: "1em" }}> {educationalSystemCode}</span>
            </div>
          );
        },
      },
      {
        title: "校資庫系所代碼",
        dataIndex: "departmentCode",
        width: 20,
      },
      {
        title: "校內系所代碼",
        width: 20,
        responsive: ["md"],
        render: (item) => {
          const { uid, departmentCodeInside } = item;
          return (
            <div>
              <Input
                placeholder={"請輸入代碼"}
                style={{
                  margin: "0 5px",
                  backgroundColor: "LightYellow",
                }}
                defaultValue={departmentCodeInside}
                onChange={(e) => this.handle_ui_field_change(uid, "BASE", e)}
              />{" "}
            </div>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_show_ui_modal = (type, item) => {
    //console.log(item);
    switch (type) {
      case "ADD":
        break;
      case "EDIT":
        break;
      case "DELETE":
        //console.log(item);
        const target = {
          schoolYear: item.schoolYear,
          schoolSemester: item.schoolSemester,
          condition: "DATE",
        };
        this.handle_delete_item(target);
        break;
      default:
    }
    this.setState({ item: item });
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    let value = e.target.value;
    if (value.length > 2) {
      const item = {
        uid: target_key,
        departmentCodeInside: value,
        condition: target_field,
      };
      //console.log(target_key)
      this.api_modify_item(item);
    } else {
      //message.info("數字僅能介於0至100");
    }
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  //////////////////////////////////////////////////////////

  render() {
    const { loading, items, academicYear, academicSemester } = this.state;
    const title = (
      <>
        <Input
          placeholder="學年度"
          style={{ width: 70, margin: "0 5px" }}
          value={academicYear}
          onChange={(event) =>
            this.setState({ academicYear: event.target.value })
          }
        />
        <Select
          value={academicSemester}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ academicSemester: value })}
        >
          <Select.Option value="1">上學期</Select.Option>
          <Select.Option value="2">下學期</Select.Option>
        </Select>
        <Button type="primary" onClick={() => this.api_list_items()}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}> 查詢</span>
        </Button>

        <Button type="primary" onClick={() => this.handle_data_download()}>
          <i className="fas fa-cloud-download-alt element-hidden"></i>
          <span style={{ marginLeft: "4px" }}> 下載</span>
        </Button>
      </>
    );
    return (
      <Card>
        <div>{title}</div>
        <p></p>
        <Table
          dataSource={items}
          columns={this.columns}
          loading={loading}
          rowKey="uid"
          scroll={{ y: 460 }}
          width="70%"
          pagination={false}
        />
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(TvedbDepartment);
